export const userSkipsAddonSelection = () => {
  return {
    type: 'User skips add-on selection',
  };
};
